import axios from 'axios'
import { apiConfig } from '../config'

export default axios.create({
    baseURL: apiConfig.baseURL,
    timeout: apiConfig.timeout
})



// WEBPACK FOOTER //
// ./src/api/index.js